export default "__VITE_ASSET__Dj0eFEtj__"